import axios from 'axios';

import config from './config';
import { getAccessToken } from './token-storage';

/**
 * Public URL of a 2nd-gen Firebase Cloud Function (served via Cloud Run).
 * Project hash and region code come from config, so a backend region move
 * (us-central1 -> europe-west2) is a config-only change on the web side.
 */
export const firebaseFunctionUrl = (name: string) =>
  `https://${name}-${config.functionsUrlCode}-${config.functionsRegionCode}.a.run.app`;

/**
 * Exchanges the app session for a Firebase custom token. This is the one
 * Firebase endpoint that cannot require a Firebase ID token (the client does
 * not have one yet), so it authenticates with the main-backend JWT instead.
 * The backend currently ignores the header (shadow mode); once enforcement
 * lands it will verify it before minting the custom token — exact contract to
 * be confirmed with the backend team.
 */
export const getFirebaseTokenRequest = ({
  email,
  phone,
  userId,
}: {
  email?: string;
  phone?: string;
  userId: string;
}) => {
  const accessToken = getAccessToken();
  return axios.post(
    firebaseFunctionUrl('getfirebasetoken'),
    {
      email,
      phone,
      userId,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
    }
  );
};
